/**
 * Link types which are used to get server address from config
 * @module gui/components/link/types
 */

/**
 * Links to the web app
 */
export const TYPE_WEB_APP = 'webApp'

/**
 * Links to the testarossa app
 */
export const TYPE_TESTAROSSA = 'testarossa'

/**
 * Links to the brightcove studio
 */
export const TYPE_BRIGHTCOVE_STUDIO = 'brightcoveStudio'
